//MessageBus Topics:
export const MB_OPEN_BETS_TOPIC = 'wh.sports.betslip.headless.open-bets';
export const MB_ON_ODDS_FORMAT_CHANGED = 'onOddsFormatChanged';
export const MB_ADD_TO_SLIP = 'wh.sports.betslip.adapter.leg.add';
export const MB_REMOVE_FROM_SLIP = 'wh.sports.betslip.adapter.leg.remove';
export const MB_BETSLIP_ACTIVE_SELECTIONS = 'wh.sports.betslip.headless.selected_selections';
export const MB_ANALYTICS_ADAPTER_READY = 'wh.analytics.adapter.ready';
export const MB_EVENT_PARTIAL = 'wh.common.command.dli.tl.eventPartial';
export const MB_TRACK_COMPLETED = 'wh.analytics.event.interaction.track.completed';
export const ANALYTICS_TRACKING_TIMEOUT_MS = 100;
export const DEFAULT_ODDS_FORMAT = 'fraction';
